import styled from 'styled-components';

export const Box = styled.div`
  background-color: #f9f9f9;
  border-left: 4px solid #5e72e4;
  padding: 16px;
  margin: 10px 0;
  border-radius: 8px;
  font-family: 'Arial', sans-serif;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

export const BoxButtons = styled.div`
  display: flex;
  flex-flow: row nowrap;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  margin-bottom: 4px;

  div {
    display: flex;
    gap: 3px;
  }
`;

export const CloseButton = styled.button`
  background: transparent;
  border: none;
  cursor: pointer;
  padding: 4px;
  display: flex;
  align-items: center;
  justify-content: center;

  svg {
    transition: transform 0.2s ease, color 0.2s ease;
  }

  &:hover svg {
    transform: scale(1.1);
    color: darkred;
  }
`;

export const ScrollButton = styled.button`
  background: transparent;
  border: none;
  cursor: pointer;
  color: #5e72e4;
  padding: 4px;
  display: flex;
  align-items: center;
  justify-content: center;

  svg {
    transition: transform 0.2s ease, color 0.2s ease;
  }

  &:hover svg {
    transform: scale(1.1);
    color: #2c4ae2;
  }
`;

export const ReplyHeader = styled.div`
  font-weight: bold;
  font-size: 0.9rem;
  color: #5e72e4;
  margin-bottom: 6px;
  padding-top: 20px;
`;

export const MetaInfo = styled.div`
  display: flex;
  justify-content: space-between;
  font-size: 0.85rem;
  color: #666;
  margin-bottom: 8px;
`;

export const Content = styled.div`
  font-size: 1rem;
  color: #333;

  p {
    margin: 0;
  }
`;

export const ReplyFooter = styled.div`
  margin-top: 10px;
  display: flex;
  align-items: center;
  font-size: 0.85rem;
  color: #666;
`;

export const AttachmentIcon = styled.span`
  margin-right: 6px;
  font-size: 1rem;
`;
